import React from 'react';
import { connect } from 'react-redux';
import {
  ServiceVariation,
  Circle,
  CircleCheck,
} from '../../components/Themed.js';
import { translateResource } from '../../data/translated_resource/TranslatedResourceActions'
import { t } from '../../locales/index.js';
import moment from "moment-timezone";

class ServicesVariationItem extends React.Component {
  constructor(props) {
    super(props);

    this.selectClick = this.selectClick.bind(this);
    this.isVariationMembersOnly = this.props.variation.members_only && this.props.company.has_memberships;
    this.disabled = this.isVariationMembersOnly && !this.clientHasAvailableMemberships();
  }

  selectClick() {
    if(this.disabled) {
      return;
    }

    this.props.onSelect(
      this.props.variation.id,
      this.props.parentVariationId,
      !this.props.selected
    );
  }

  clientHasAvailableMemberships() {
    const {
      clientInformation: { client_memberships },
      selectedChildId,
    } = this.props;

    return client_memberships?.some((membership) => {
      if (!this.isMembershipActive(membership)) {
        return false;
      }

      if (!membership.my_client_child_id && !membership.client_only) {
        return true;
      }

      if(!selectedChildId && membership.client_only) {
        return true;
      }

      // eslint-disable-next-line
      if (selectedChildId == membership.my_client_child_id) {
        return true;
      }

      return false;
    });
  }

  isMembershipActive(membership) {
    const {
      memberships_should_apply_dollar_credits_when_paused,
      memberships_should_apply_service_credits_when_paused,
      memberships_should_apply_discounts_when_paused,
      memberships_should_apply_service_credits_when_suspended,
      memberships_should_apply_dollar_credits_when_suspended,
    } = this.props.company;

    if (
      membership.status === "active" ||
      membership.status === "pending_cancelation"
    ) {
      return true;
    }

    if (membership.status === "paused") {
      return (
        memberships_should_apply_dollar_credits_when_paused ||
        memberships_should_apply_service_credits_when_paused ||
        memberships_should_apply_discounts_when_paused
      );
    }

    if (membership.status === "suspended") {
      return (
        memberships_should_apply_service_credits_when_suspended ||
        memberships_should_apply_dollar_credits_when_suspended
      );
    }

    if (membership.status === 'canceled') {
      return membership.client_benefits.some(({ benefits }) =>
        benefits.some(benefit => this.isValidValueOrItemCredit(benefit))
      );
    }

    return false;
  }

  isValidValueOrItemCredit(benefit) {
    if (!benefit) {
      return;
    }

    const today = moment();
    const validityStartTime = moment(benefit.validity_start_time);
    const validityEndTime = moment(benefit.validity_end_time);

    return (benefit.type === 'client_credit' || benefit.type === 'bundle_purchase') &&
    today.isSameOrAfter(validityStartTime) &&
    today.isBefore(validityEndTime);
  };

  render() {
    const { variation, selected, addon, price, currencySymbol, translateResource, company } = this.props;
    if (price == null || price.minPrice == null) return null;

    let priceRange =
      price.minPrice === price.maxPrice
        ? currencySymbol + price.minPrice.toFixed(2)
        : currencySymbol + price.minPrice.toFixed(2) + '-' + currencySymbol + price.maxPrice.toFixed(2);

    if (price.minPrice === 0 && price.maxPrice === 0) {
      priceRange = currencySymbol + price.minPrice.toFixed(2);
    }

    return (
      <ServiceVariation
        selected={selected}
        addon={addon}
        onClick={this.selectClick}
        className={this.disabled ? "variation-disabled" : ""}
      >
        <Circle inverse={addon && selected}>
          <CircleCheck
            className="fas fa-check"
            style={{
              opacity: selected ? 1 : 0,
            }}
          />
        </Circle>
        <div>
          <div
            className={'services-text' + (addon ? ' services-text-addon' : '')}
          >
            {addon ? '' : ''}
            {translateResource('Variation', variation).name} {company.hide_price_on_kiosk ? '' : priceRange}
          </div>
          {variation.description && <pre className="multiline-box">
            {variation.description}
          </pre>}
        </div>
        {this.isVariationMembersOnly && <span className="members-only-label">{t("services.members_only")}</span>}
      </ServiceVariation>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    clientInformation: state.client.clientInformation,
    company: state.app.businessInfo.company,
    selectedChildren: state.client.childrenSelectedForServices,
  };
}

export default connect(
  mapStateToProps,
  { translateResource }
)(ServicesVariationItem)